import React from 'react';
import { Stack, Typography } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import { useTutorUser } from 'hooks/useUser';
import { maskPhone } from 'util/masks';

export const TutorMyPlanUserInfo: React.FC = () => {
  const { user } = useTutorUser();

  if (!user?._id) {
    return null;
  }

  return (
    <Stack justifyContent="center" mr={6}>
      {[
        {
          icon: <AccountCircleIcon htmlColor="#979797" />,
          value: user.name,
        },
        {
          icon: <MailIcon htmlColor="#979797" />,
          value: user.email,
        },
        {
          icon: <PhoneIcon htmlColor="#979797" />,
          value: maskPhone(user.phone),
        },
      ].map(({ icon, value }, index) => (
        <Stack alignItems="center" key={index} direction="row" spacing={1}>
          {icon}

          <Typography color="#616161" fontSize={18} fontWeight={400}>
            {value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
